export default __webpack_public_path__ + "static/media/btn-mallview-user.9c91a533.svg";